import { ActionWithPayload } from "../model";

import { STORE_CACHE_TYPE } from "./state-cache.action";
import { SetFetchedActionPayload, StateCacheState } from "./state-cache.model";

const INITIAL_STATE: StateCacheState = {};

export function stateCacheReducer(state = INITIAL_STATE, action: ActionWithPayload): StateCacheState {
	switch (action.type) {
		case STORE_CACHE_TYPE.clearCache: {
			const key: string = action.payload;

			const newState = { ...state };
			delete newState[key];

			return newState;
		}
		case STORE_CACHE_TYPE.clearAllCache: {
			return INITIAL_STATE;
		}
		case STORE_CACHE_TYPE.setFetched: {
			const payload: SetFetchedActionPayload = action.payload;

			return {
				...state,
				[payload.cacheKey]: {
					timestamp: Date.now(),
					onServer: payload.isServer,
				},
			};
		}
	}

	return state;
}
